<template>
  <div
    class="flex flex-col border-iq-white-border border-2 place-content-end p-8 place-items-center min-h-[17.25rem] min-w-[18.5rem] max-h-[17.25rem] max-w-[18.5rem] h-69 w-74"
    :class="{
      'hover:cursor-pointer hover:border-iq-beige': !props.disableHover,
    }"
  >
    <NuxtImg
      class="!w-40 !h-40 focus:bg-iq-grey-dark"
      :src="props.icon"
      placeholder
    />
    <div class="flex flex-col items-center">
      <div class="text-regular-22">{{ props.title }}</div>
      <div v-if="props.subtitle" class="text-regular-14">
        {{ props.creditsInfo }}
      </div>
      <div
        v-if="props.subtitle"
        class="text-regular-14 flex flex-col items-center"
      >
        <span> {{ props.subtitle }}</span>

        <span class="text-regular-12">{{ t('taxNotice') }}</span>
      </div>
      <!-- placeholder if no subtitle is given, to prevent layout shift -->
      <div v-if="!props.subtitle" class="!text-transparent text-regular-18">
        [PLACEHOLDER]
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  creditsInfo?: string;
  disableHover?: boolean;
  icon: string;
  isActive?: boolean;
  subtitle?: string;
  title: string;
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "de": {
    "taxNotice": "* zzgl. MwSt"
  },
  "en": {
    "taxNotice": "* plus VAT"
  }
}
</i18n>
